import { PagedMultiSelectField, PagedSingleSelectField, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { tenantService } from "../api/tenantService";

interface Props {
	name: string;
	label: string;
	required?: boolean;
	clearable?: boolean;
	disabled?: boolean;
}

const fetchConfig = laravelServiceSelectFetchConfig(tenantService);

export const TenantSingleSelect: FC<Props> = (props) => {
	return <PagedSingleSelectField {...props} fetchConfig={fetchConfig} />;
};

export const TenantMultiSelect: FC<Props> = (props) => {
	return <PagedMultiSelectField {...props} fetchConfig={fetchConfig} />;
};
